import React from 'react'
import { Container } from './styled'

type Props = {
  icon: React.ReactNode
  transform?: number
}

export const ActionCardIcon = ({ icon, transform }: Props) => {
  return <Container transform={transform}>{icon}</Container>
}
